import React, { useMemo } from 'react'
import { SelectDropdown, type DropDownItemOptionComponentProps, type SelectOption } from '../../../SelectDropdown/SelectDropdown'
import { type ZocksReferenceWidgetProps } from './registry'

interface ReferencePickerProps extends ZocksReferenceWidgetProps {
  options: SelectOption[]
  loading: boolean
  dropDownItemOptionComponent?: React.ComponentType<DropDownItemOptionComponentProps>
}

export const ReferencePicker: React.FC<ReferencePickerProps> = ({
  options,
  loading,
  value,
  onChange,
  disabled,
  required,
  label,
  id,
  dropDownItemOptionComponent,
  excludeIds,
}) => {
  const availableOptions = excludeIds?.length ? options.filter((option) => option.id === value || !excludeIds.includes(option.id)) : options
  const matchedLabel = availableOptions.find((option) => option.id === value)?.label
  const selectedOption = useMemo<SelectOption | null>(() => {
    if (matchedLabel !== undefined) {
      return { id: value, label: matchedLabel }
    }
    return value ? { id: value, label: `${value} (not found)` } : null
  }, [value, matchedLabel])
  const dropdownOptions = selectedOption && matchedLabel === undefined ? [selectedOption, ...availableOptions] : availableOptions

  return (
    <SelectDropdown
      options={dropdownOptions}
      initialSelectedOption={selectedOption}
      searchable
      loading={loading}
      disabled={disabled}
      placeholder='Select…'
      showDeselectOption={!required}
      onDeselect={() => onChange(undefined)}
      onOptionSelected={(option) => onChange(option.id)}
      ariaLabel={label}
      toggleId={id}
      DropDownItemOptionComponent={dropDownItemOptionComponent}
    />
  )
}
